import { useEffect, useState } from "react";





import { useNavigate } from 'react-router-dom';

import {  toast } from 'react-toastify';

import GlobalSearch from "./component";
import { useApiRequest } from "../Login/Hooks/useApiRequest";
import { API_BASE_URL } from "../../config";


const GlobalSearchContainer = (props) => {
   const { makeApiRequest } = useApiRequest()





  const navigate =useNavigate()

  const [flagMp,setFlagMp]=useState(true)

const [globalSearchProName,setGlobalSearchProName]=useState("")
const [vmwiseInventoryFlag,setVmwiseInventoryFlag]=useState(false)
const [globalsearchTerm,setGlobalsearchTerm]=useState(null)
const [globalvmList,setGlobalvmList]=useState([])
const [cartCount,setCartCount]=useState(null);
const [carttotalAmount,setCarttotalAmount]=useState(null)
const [ItemDetails,setItemDetails]=useState(null)
const [MachineDetails,setMachineDetails]=useState(null)
const [VmWiseInventroyList,setVmWiseInventroyList]=useState(null)
const [PreCartListGlobal,setPreCartListGlobal]=useState(null)
const [PreCartMachineID,setPreCartMachineID]=useState(null)
const [CategoryDetails,setCategoryDetails]=useState(null)
const [ActiveOrderItemsListGlobal,setActiveOrderItemsListGlobal]=useState()
const [replaceCard,setReplceCard]=useState(false)
const [slotId,setSlotdId]=useState(null)

const handleResponseGlobalSearch=(res,searchTerm)=>{
//console.log("handleResponseGlobalSearch",res.data.data.categoryDetails)
   
 	//mpSearchResult({EventName:"Global_search_successful",data:{search_query:searchTerm,count:res.data.data.categoryDetails.length+res.data.data.itemDetails.length+res.data.data.machineDetails.length}})
setCategoryDetails(res.data.data.categoryDetails)
setItemDetails(res.data.data.itemDetails)
setMachineDetails(res.data.data.machineDetails)
  setVmwiseInventoryFlag(false)

//machineDetails

}

const handleErrorActiveOrders=(res)=>{
/*   toast.error(`${res}`, {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: 1000,
  }); */
}

const handleErrorVmWiseInventory=(error)=>{
  toast.error(`${error}`, {
    //position: toast.POSITION.TOP_RIGHT,
    //autoClose: 1000,
  });

}
const handleResponseVmWiseInventory=(res)=>{
  //console.log("res----------",res.data.data)
  setVmWiseInventroyList(res.data.data)
  
  setVmwiseInventoryFlag(true)
  fetchPreCard()

//console.log("handleResponseVmWiseInventory",res)
setFlagMp(false)

}
const globalSearchflagBackbtn=(e)=>{
  e.preventDefault()
 navigate("/")
}
useEffect(()=>{


  globalSearch()
  fetchPreCard()
  fetchActiveOrder()
},[])



const handleErrorClearPreCard=()=>{

}


const handleResponseClearPreCard=(res)=>{
 // console.log("")
  setReplceCard(false)
  console.log("khan slotDAta",slotId)
  addintoCart("tahzeev",slotId.sId,slotId.vmId,slotId.count)

fetchPreCard()
//AddIntoCart("tahzeeb",addThisSlot.index,addThisSlot.sId,0)

setReplceCard(false)

}


      const fetchClearPreCard = () => {
        const UserJWTAuth = localStorage.getItem("UserJWTAuth");
      


                   makeApiRequest({
       //url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/cart`,
       URL: `${API_BASE_URL}/consumerbe/api/v2/cart`,
      method: "DELETE",
             headers: {
          Authorization: `Bearer ${UserJWTAuth}`,
          "x-app-platform": "web",
          "x-app-version": "v1.0.1",
          "x-device-id": localStorage.getItem("uuid"),
        },
        data:{
    
        request:{}


      },
      handleSuccess: (res) => handleResponseClearPreCard(res),
      handleError:(error)=> handleErrorClearPreCard(error),
    });





      };


let totalitemcount=0,totalAmount=0
useEffect(()=>{
  

  setCartCount(totalitemcount)
  setCarttotalAmount(totalAmount)
  //console.log("props&&props.totalitemcount",totalitemcount,totalAmount)
  //console.log("handleResponse");
  //console.log("handleResponsePreCard" );

},[PreCartListGlobal])







const globalSearchflag=(e)=>{
  e.preventDefault()
 
}
const globalSearch = (searchTerm) => {
  //console.log("globalSearch",searchTerm)

  setVmwiseInventoryFlag(false)
  setGlobalSearchProName(searchTerm)
  setGlobalsearchTerm(searchTerm)
  if(globalSearchProName)
  {setGlobalSearchProName((prevValue) => prevValue.slice(0, -1));
  }
 



  const UserJWTAuth = localStorage.getItem('UserJWTAuth');
  const lat = localStorage.getItem('lat');
  const lng = localStorage.getItem('lng');
  
  if(searchTerm){
  //console.log("searchTerm ",searchTerm)
  if(searchTerm){
}




                  makeApiRequest({
// url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/search/global?searchQuery=${searchTerm}&lat=${lat}&lng=${lng}`,
    url: `${API_BASE_URL}/consumerbe/api/v2/search/global?searchQuery=${searchTerm}&lat=${lat}&lng=${lng}`,
    method: "GET",
             headers: {
          Authorization: `Bearer ${UserJWTAuth}`,
          "x-app-platform": "web",
          "x-app-version": "v1.0.1",
         // "x-device-id": localStorage.getItem("uuid"),
        },
  
      handleSuccess: (res) => {handleResponseGlobalSearch(res,searchTerm)},
      handleError:(error)=> handleErrorActiveOrders(error),
    });

  }


};

const backFromGlobalSearch=()=>{
  setVmwiseInventoryFlag(false)

}

const vmWiseInvertory = (e,id,type,name) => {
  
 
  e.preventDefault()  
  setGlobalSearchProName(name)

const UserJWTAuth = localStorage.getItem('UserJWTAuth');
const lat = localStorage.getItem('lat');
const lng = localStorage.getItem('lng'); 

  


                  makeApiRequest({
      //url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/outlet-wise/inventory?page=0&size=100&recentLimit=6&lat=${lat}&lng=${lng}&${type}=${id}`,
      url: `${API_BASE_URL}/consumerbe/api/v2/outlet-wise/inventory?page=0&size=100&recentLimit=6&lat=${lat}&lng=${lng}&${type}=${id}`,
    method: "GET",
             headers: {
          Authorization: `Bearer ${UserJWTAuth}`,
          "x-app-platform": "web",
          "x-app-version": "v1.0.1",
          "x-device-id": localStorage.getItem("uuid"),
        },
        data:{
    
        request:{}


      },
      handleSuccess: (res) => {handleResponseVmWiseInventory(res)},
      handleError:(error)=> handleErrorVmWiseInventory(error),
    });


};







const addintoCart = (e,sId,vmId,count,name,mrp) => {

 //console.log("khan--e,sId,vmId,count",e,sId,vmId,count,name,mrp)
 setSlotdId({sId:sId,vmId:vmId,count:count})
  localStorage.setItem("Global_Slot_id",sId)

const UserJWTAuth = localStorage.getItem('UserJWTAuth');
const lat = localStorage.getItem('lat');
const lng = localStorage.getItem('lng'); 

  




                  makeApiRequest({
       // url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/cart?machineId=${vmId}`,  
        url: `${API_BASE_URL}/consumerbe/api/v2/cart?machineId=${vmId}`,
     method: "PATCH",
             headers: {
          Authorization: `Bearer ${UserJWTAuth}`,
          "x-app-platform": "web",
          "x-app-version": "v1.0.1",
          "x-device-id": localStorage.getItem("uuid"),
        },
        data:
    
       [{
        slotId: parseInt(sId), // Parsing sId to an integer
        count: count + 1,    }  // Incrementing the count by 1
       ]


      ,
      handleSuccess: (res) => handleResponseAddToCart(res,vmId),
      handleError:(res,sId,vmId ,count)=>handleErrorAddToCart(res,sId,vmId ,count) ,
    });



};

const handleErrorAddToCart=(res,sId,vmId ,count)=>{

toast.error(`${res.response.data.status.message}`, {
  position: toast.POSITION.TOP_RIGHT,
  autoClose: 1000,
});
if(!(res.response.data.status.code=="NOT_FOUND"))
{
setReplceCard(true)
}
}

const handleResponseAddToCart=(res,vmId)=>{
//console.log("tahzeeb handleResponseAddToCart",res)
navigate(`/items?machineId=${vmId}&showItems=true`)
//fetchPreCard()
}

const SetVm=(e,id,name,address)=>{
  //console.log("Setvm VM ID",id)
  navigate(`/items?machineId=${id}&showItems=true`,{ replace: true })
  localStorage.setItem("vmName",name)
  localStorage.setItem("vmAddress",address)
 

}



const fetchPreCard = () => {
  const UserJWTAuth = localStorage.getItem("UserJWTAuth");





                  makeApiRequest({
       // url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/cart`,
        url: `${API_BASE_URL}/consumerbe/api/v2/cart`,
     method: "GET",
             headers: {
          Authorization: `Bearer ${UserJWTAuth}`,
          "x-app-platform": "web",
          "x-app-version": "v1.0.1",
          "x-device-id": localStorage.getItem("uuid"),
        },
        data:{
    
       
        //slotId: parseInt(sId), // Parsing sId to an integer
       // count: count + 1,      // Incrementing the count by 1
      


      },
      handleSuccess: (res) => handleResponsePreCardGlobal(res),
      handleError:(res)=>handleErrorPreCardGlobal() ,
    });





};

const handleResponsePreCardGlobal=(res)=>{
console.log("handleResponsePreCardGlobal",res.data.data)
setPreCartListGlobal(res.data.data)

}

const handleErrorPreCardGlobal=(error)=>{
  if(error.response.status==401|| error.response.status==403){

    //console.log("khan handleErrorVmInventory", error.response.data.status.code);
    //Logout
    //localStorage.removeItem("UserJWTAuth")
    navigate("/login");
}
else{ toast.error(`${error.response.data.status.code}`, {
  position: toast.POSITION.TOP_RIGHT,
  autoClose: 1000,
});
}


  
}



/////////////////  ACTIVE ORDERS DATA FETCHING
const fetchActiveOrder = () => {
  const UserJWTAuth = localStorage.getItem("UserJWTAuth");



               makeApiRequest({
       // url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/order/active`,
        url: `${API_BASE_URL}/consumerbe/api/v2/order/active`,
     method: "GET",
             headers: {
          Authorization: `Bearer ${UserJWTAuth}`,
          "x-app-platform": "web",
          "x-app-version": "v1.0.1",
          "x-device-id": localStorage.getItem("uuid"),
        },
        data:{
    
       
    
      


      },
      handleSuccess: (res) => handleResponseActiveOrdersGlobal(),
      handleError:(res)=>handleErrorActiveOrdersGlobal() ,
    });




};

const handleResponseActiveOrdersGlobal=(res)=>{
//console.log("handleResponseActiveOrders",res)
}

const handleErrorActiveOrdersGlobal=(res)=>{

  toast.error(`${res}`, {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: 1000,
  });
//console.log("handleErrorActiveOrdersGlobal",res)

}
  
  const removefromCart=( e,slotId,vmId,count)=>{

    navigate(`/items?machineId=${vmId}&showItems=true`)
  }
  
  
  


return(<>

<GlobalSearch
globalSearch={globalSearch}
globalSearchProName={globalSearchProName}
globalSearchflagBackbtn={globalSearchflagBackbtn}
globalSearchflag={globalSearchflag}
CategoryDetails={CategoryDetails}
ItemDetails={ItemDetails}
MachineDetails={MachineDetails}
globalsearchTerm={globalsearchTerm}
vmwiseInventoryFlag={vmwiseInventoryFlag}
globalvmList={globalvmList}
vmWiseInvertory={vmWiseInvertory}
VmWiseInventroyList={VmWiseInventroyList}
addintoCart={addintoCart}
PreCartListGlobal={PreCartListGlobal}
ActiveOrderItemsListGlobal={ActiveOrderItemsListGlobal}
cartCount={cartCount}
carttotalAmount={carttotalAmount}
PreCartMachineID={PreCartMachineID}
removefromCart={removefromCart}
SetVm={SetVm}
backFromGlobalSearch={backFromGlobalSearch}
fetchClearPreCard={fetchClearPreCard}
replaceCard={replaceCard}
setReplceCard={setReplceCard}
setFlagMp={setFlagMp}
flagMp={flagMp}

/>

</>)
}




  export default GlobalSearchContainer